import type { BillingSummary } from "./api.ts";

// Paying, as the views ask about it (features/paying.md).

// Buying a Trip Pass: Stripe's Checkout in this tab, and back to `returnTo` after.
export const buyPass = (returnTo: string) => `/buy/trip-pass?from=web&return_to=${encodeURIComponent(returnTo)}`;

// Buying Frequent Flyer, the yearly plan: the same, a subscription.
export const buyFrequentFlyer = (returnTo: string) =>
  `/buy/frequent-flyer?from=web&return_to=${encodeURIComponent(returnTo)}`;

// Frequent Flyer's renewal, said right beside every button that buys it (features/paying.md, "Gotchas":
// automatic-renewal laws want the terms clear and next to the request to pay), at the catalog's price. `named`
// starts it with the plan's name, where the line could be read as the Trip Pass's.
export const renewal = (price: string, { named = false }: { named?: boolean } = {}) =>
  `${named ? "Frequent Flyer renews" : "Renews"} every year at ${price} until you cancel. Cancel any time from your profile and keep it to the end of the year.`;

// Whether starting a trip needs a Trip Pass first: no plan, no pass waiting, and the gate is on.
export const needsPass = (billing: BillingSummary) => billing.plan === "none" && !billing.can_create_trip;
